import Reveal from 'components/Reveal';
import React from 'react';
import { Link } from 'react-router-dom';

const FooterComp = () => {
  return (
    <Reveal>
      <div className="px-6 py-5">
        <div className="container mx-auto mb-2 flex flex-wrap justify-between gap-5 md:flex-row">
          <div className="basis-[40%] p-3 md:basis-1/4">
            <p className="text-lg font-bold">SUPPORT</p>
            <div className="mt-2 flex flex-col gap-y-3">
              <p className="text-lg">
                <Link to="/about">About Us</Link>
              </p>
              <p className="text-lg">
                <Link to="/contact">Contact Us</Link>
              </p>
              <p className="text-lg">
                <Link to="/services">Services</Link>
              </p>
            </div>
          </div>
          <div className="basis-[40%] p-3 md:basis-1/4">
            <p className="text-lg font-bold">QUICK LINKS</p>
            <div className="mt-2 flex flex-col gap-y-3">
              <p className="text-lg">
                <Link to="/register">Sign Up</Link>
              </p>
              <p className="text-lg">
                <Link to="/login">Login</Link>
              </p>
              <p className="text-lg">
                <Link to="#">Terms of use</Link>
              </p>
            </div>
          </div>
          <div className="basis-full p-3 md:basis-1/4">
            <p className="text-lg font-bold">COMPANY</p>
            <div className="mt-2 flex flex-col gap-y-3">
              <p className="text-lg">
                <Link to={'/about'}>Home</Link>
              </p>
              <p className="text-lg">
                <Link to={'/about'}>Contact Us</Link>
              </p>
              <p className="text-lg">
                <Link to={'/about'}>Services</Link>
              </p>
            </div>
          </div>
        </div>
        <div className="container mx-auto p-3">
          <hr />
          <br />
          <div className="my-2 flex items-center gap-x-2">
            <img
              src="/assets/icons/facebook.svg"
              alt="facebook"
              className="h-[32px] w-[32px]"
            />
            <img
              src="/assets/icons/telegram.svg"
              alt="telegram"
              className="h-[25px] w-[25px]"
            />
            <img
              src="/assets/icons/whatsapp.svg"
              alt="whatsapp"
              className="h-[25px] w-[25px]"
            />
            <img
              src="/assets/icons/instagram.svg"
              alt="instagram"
              className="h-[30px] w-[30px]"
            />
          </div>
          <p className="my-3 text-lg leading-8 text-gray-500">
            Trading with derivatives and leveraging can carry significant risks,
            including the chance of losing much more than your initial
            investment. This type of investing isn't for everyone. Before making
            any decisions related to a financial product, we recommend you
            obtain and review our Product Disclosure Statement (PDS) and
            Financial Services Guide (FSG), which you can find on our website.
            If needed, don't hesitate to seek independent advice.
          </p>
          <div id="google_translate_element" />
          <p className="text-lg font-bold">Blockchain.com, Inc. NMLS</p>
          <p className="text-lg font-bold">ID# 2024031.</p>
        </div>
      </div>
    </Reveal>
  );
};

export default FooterComp;
